var map = {
	"./additionalInfoIcon.svg": 624,
	"./arrowLeftIcon.svg": 625,
	"./arrowMediumTop.svg": 626,
	"./arrowRightIcon.svg": 627,
	"./arrowRightIconSharp.svg": 628,
	"./arrowRightSmallIcon.svg": 629,
	"./arrowScalableIcon.svg": 630,
	"./arrowSelect2.svg": 631,
	"./arrowSelectIcon.svg": 632,
	"./benefit1.svg": 633,
	"./benefit2.svg": 634,
	"./benefit3.svg": 635,
	"./cardsIcon.svg": 636,
	"./checkCirсleIcon.svg": 637,
	"./circleInfoIcon.svg": 638,
	"./copyIcon copy.svg": 639,
	"./copyIcon.svg": 640,
	"./crossIcon.svg": 641,
	"./crossIcon2.svg": 642,
	"./crossIcon3.svg": 643,
	"./crossIconSmall.svg": 644,
	"./crossSmallIcon.svg": 645,
	"./defaultCategoryIcon.svg": 646,
	"./depNumberIcon.svg": 647,
	"./elfCentralIcon.svg": 648,
	"./equalitySign.svg": 649,
	"./errorIcon.svg": 650,
	"./eyeClosedIcon.svg": 651,
	"./eyeOpenIcon.svg": 652,
	"./favoritesIcon.svg": 653,
	"./favoritesLabelIcon.svg": 654,
	"./filterDivider.svg": 655,
	"./filterIcon.svg": 656,
	"./frequencyIcon.svg": 657,
	"./fsAmountIcon.svg": 658,
	"./fullScreenIcon.svg": 659,
	"./gameIcon.svg": 660,
	"./goldGiftIcon.svg": 661,
	"./hamburgerIcon.svg": 662,
	"./infoIcon.svg": 663,
	"./infoSymbol.svg": 664,
	"./levelBackground.svg": 665,
	"./levelBackgroundNew.svg": 666,
	"./linkIcon.svg": 667,
	"./lockIcon.svg": 668,
	"./lockSharpIcon.svg": 669,
	"./maxBonusAmountIcon.svg": 670,
	"./maxWinFsIcon.svg": 671,
	"./menu/fortuneIcon.svg": 385,
	"./menu/fortuneIconL.svg": 386,
	"./menu/helpdeskIcon.svg": 387,
	"./menu/helpdeskIconL.svg": 388,
	"./menu/homeIcon.svg": 389,
	"./menu/homeIconLarge.svg": 390,
	"./menu/jackpotIcon.svg": 391,
	"./menu/logo.svg": 392,
	"./menu/logoSmall.svg": 393,
	"./menu/loyaltyIcon.svg": 394,
	"./menu/mobileAppIcon.svg": 395,
	"./menu/profileIcon.svg": 396,
	"./menu/questIcon.svg": 397,
	"./menu/questsIcon.svg": 398,
	"./menu/rewardLineupIcon.svg": 399,
	"./menu/searchIcon.svg": 400,
	"./menu/searchIconLarge.svg": 401,
	"./menu/signOutIcon.svg": 402,
	"./menu/star.svg": 403,
	"./menu/tournamentIcon.svg": 404,
	"./menu/tournamentLargeIcon.svg": 405,
	"./menu/vipIcon.svg": 406,
	"./menu/wheelIcon.svg": 407,
	"./menu/wheelIconL.svg": 408,
	"./menu/wheelIconMobile.svg": 409,
	"./menuIcon.svg": 672,
	"./minDepIcon.svg": 673,
	"./noTournamentIcon.svg": 674,
	"./numbers/number-1.svg": 410,
	"./numbers/number-2.svg": 411,
	"./numbers/number-3.svg": 412,
	"./numbers/number-4.svg": 413,
	"./numbers/number-5.svg": 414,
	"./numbers/number-6.svg": 415,
	"./numbers/number-7.svg": 416,
	"./numbers/number-8.svg": 417,
	"./numbers/number-9.svg": 418,
	"./numbers/number-shine-1.svg": 419,
	"./numbers/number-shine-2.svg": 420,
	"./numbers/number-shine-3.svg": 421,
	"./numbers/number-shine-4.svg": 422,
	"./numbers/number-shine-5.svg": 423,
	"./numbers/number-shine-6.svg": 424,
	"./numbers/number-shine-7.svg": 425,
	"./numbers/number-shine-8.svg": 426,
	"./numbers/number-shine-9.svg": 427,
	"./playIcon.svg": 675,
	"./polygon.svg": 676,
	"./preloaderDotsAnimation.svg": 677,
	"./preloaderSpinnerAnimation.svg": 678,
	"./present2Icon.svg": 679,
	"./presentIcon.svg": 680,
	"./promoIcon.svg": 681,
	"./recentIcon.svg": 682,
	"./search2Icon.svg": 683,
	"./search3Icon.svg": 684,
	"./sharpTickIcon copy.svg": 685,
	"./sharpTickIcon.svg": 686,
	"./smallInfoSymbol.svg": 687,
	"./smoothArrowIcon.svg": 688,
	"./successIcon.svg": 689,
	"./supportIcon.svg": 690,
	"./tag1Icon.svg": 691,
	"./tag2Icon.svg": 692,
	"./tag3Icon.svg": 693,
	"./tag4Icon.svg": 694,
	"./tickIcon.svg": 695,
	"./unverified.svg": 696,
	"./verified.svg": 697,
	"./wagerIcon.svg": 698,
	"./wagerTimeIcon.svg": 699,
	"./warningIcon.svg": 700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;